import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6589d17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-item" }
const _hoisted_2 = { class: "goods-item-img flex-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "goods-item-text" }
const _hoisted_5 = { class: "cn-price" }
const _hoisted_6 = { class: "other-price" }
const _hoisted_7 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/collect.png",
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/collected.png",
  alt: ""
}

import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { isJA, isKO } from '@/store'
import { formatMoneyDirection, calc } from '@/util/useYan'
import GoodsLink from '@/components/common/GoodsLink.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['item', 'index'],
  emits: ['change'],
  setup(__props, { emit: emits }) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GoodsLink, { goods: __props.item }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "hotIcon"),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: __props.item.productMainImg,
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(isJA)() ? (__props.item.productTitleJp || __props.item.productTitle) : __props.item.productTitle), 1),
        _createElementVNode("div", {
          class: "goods-item-price",
          style: _normalizeStyle(`color: ${_unref(isKO)() ? '#333333' : 'red'};`)
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(`${__props.item.productSellPrice}${_unref(t)("元")}`), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(`（${_unref(formatMoneyDirection)(_unref(calc)(__props.item.productSellPrice))}）`), 1)
        ], 4)
      ]),
      _: 3
    }, 8, ["goods"]),
    _createElementVNode("div", {
      class: "goods-collect",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('change', __props.item)), ["stop"]))
    }, [
      (!__props.item.favoriteFlag)
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : (_openBlock(), _createElementBlock("img", _hoisted_8))
    ])
  ]))
}
}

})